import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Color } from "../../";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
var StyledComponent = styled(function (props) {
    //thumb 스타일 (Switch 내부 버튼)
    var thumbStyle = (props === null || props === void 0 ? void 0 : props.disabled) ? {
        border: 'none',
        backgroundColor: Color.primary.white,
    } : {
        border: "1px solid ".concat(Color.component.gray),
        backgroundColor: Color.primary.white,
    };
    var checkedThumbStyle = (props === null || props === void 0 ? void 0 : props.disabled) ? {
        border: 'none',
        backgroundColor: Color.component.gray_light
    } : {
        border: 'none',
        backgroundColor: Color.primary.white
    };
    //track 스타일 (Switch 버튼 외부)
    var trackStyle = (props === null || props === void 0 ? void 0 : props.disabled) ? {
        backgroundColor: Color.component.gray_light,
        border: "1px solid ".concat(Color.component.gray_light),
    } : {
        backgroundColor: Color.component.gray_light,
        border: "1px solid ".concat(Color.component.gray),
    };
    var checkedTrackStyle = (props === null || props === void 0 ? void 0 : props.disabled) ? {
        backgroundColor: Color.component.gray,
        opacity: 1,
        border: "1px solid ".concat(Color.component.gray)
    } : {
        backgroundColor: Color.primary.main,
        opacity: 1,
        border: "1px solid ".concat(Color.primary.main),
    };
    return (_jsx("div", { id: props === null || props === void 0 ? void 0 : props.id, "data-current-value": props === null || props === void 0 ? void 0 : props.checked, children: _jsx(FormControlLabel, { sx: {
                padding: 0,
                margin: 0,
                opacity: 1,
            }, control: _jsx(Switch, { name: props === null || props === void 0 ? void 0 : props.label, checked: props === null || props === void 0 ? void 0 : props.checked, onChange: props === null || props === void 0 ? void 0 : props.onChange, disabled: props === null || props === void 0 ? void 0 : props.disabled, sx: {
                    width: "32px",
                    height: "16px",
                    padding: 0,
                    margin: "4px",
                    "& .MuiSwitch-switchBase": {
                        padding: 0,
                        margin: 0,
                        transitionDuration: "300ms",
                        "&:hover": {
                            backgroundColor: "transparent",
                        },
                        /** Checked 되었을 경우! */
                        "&.Mui-checked": {
                            transform: "translateX(1rem)",
                            color: "#fff",
                            ".MuiSwitch-thumb": checkedThumbStyle,
                            "& + .MuiSwitch-track": checkedTrackStyle,
                        },
                        "&.Mui-focusVisible .MuiSwitch-thumb": {
                            color: "#33cf4d",
                            border: "6px solid #000",
                            backgroundColor: "#000",
                        },
                        "&.Mui-disabled .MuiSwitch-thumb": {
                            color: "#EEEEEE",
                        },
                        "&.Mui-disabled + .MuiSwitch-track": {
                            opacity: 1,
                        },
                    },
                    /** UnChecked 되었을 경우! */
                    "& .MuiSwitch-thumb": __assign({ boxSizing: "border-box", width: "12px", height: "12px", marginTop: "2px", marginLeft: "2px", boxShadow: "none" }, thumbStyle),
                    "& .MuiSwitch-track": __assign({ width: "30px", height: "14px", boxSizing: "content-box", borderRadius: 26 / 2, opacity: 1, transition: "background-color 300ms linear" }, trackStyle),
                } }), label: props === null || props === void 0 ? void 0 : props.label }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
